import { render, staticRenderFns } from "./UserVerify.vue?vue&type=template&id=3b805c32&scoped=true"
import script from "./UserVerify.vue?vue&type=script&lang=js"
export * from "./UserVerify.vue?vue&type=script&lang=js"
import style0 from "./UserVerify.vue?vue&type=style&index=0&id=3b805c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b805c32",
  null
  
)

export default component.exports